import { Empty, notification } from "antd";
import esES from 'antd/lib/locale/es_ES';
import { getActiveServices } from "api";
import { InternalPageLayout, Table } from "components";
import { usePermissions } from "hooks";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanCurrentService } from "store/service";
import { dayServicesColumns } from "utils/tableColumns";

const NextServices = () => {
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { can } = usePermissions();
    const canWrite = can("sales", "write");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const gettingServices = async () => {
        if (!isLoading)
            setIsLoading(true);
        try {
            const {data, errors} = await getActiveServices();
            if (data) {
                setServices(data);
            } else {
                setServices([]);
                notification.error({
                    message: "Listado de Proximos Servicios",
                    description: errors
                });
            }
            setIsLoading(false);
        } catch (error:any) {
            setServices([]);
            setIsLoading(false);
            notification.error({
                message: "Listado de Proximos Servicios",
                description: error.message
            });
        }
    }

    useEffect(() => {
        gettingServices();
        dispatch(cleanCurrentService());
    }, [])

    return (
        <InternalPageLayout title="Proximos Servicios">
            <Table
                localeProv={esES}
                columns={dayServicesColumns(navigate, dispatch, canWrite)}
                dataSource={services}
                size="small"
                rowKey={'id'}
                // dataSource={search ? filterHunters() : hunters}
                locale={{
                    triggerDesc: 'Ordenar de forma descendente',
                    triggerAsc: 'Ordenar de forma ascendente',
                    cancelSort: 'Cancelar ordenamiento',
                    emptyText: (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No hay datos"
                    />
                    )
                }}
                scroll={{ x: 'auto' }}
                pagination={{ defaultPageSize: 10 }}
                loading={isLoading}
            />
        </InternalPageLayout>
    )
}
export default NextServices;
